import React from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';

import { FilterOption } from './Menu.style';
import { ColorTag, ColorOption } from './ColorMenu.style';
import { getLabel } from '../../utils';

interface ColorMenuProps {
  optionList: string[];
  activeValue: string[];
  updateFilter: (filter: 'multiColor' | 'seo_colors', value: string[]) => void;
}

export const ColorMenu: React.FC<ColorMenuProps> = ({ optionList, activeValue, updateFilter }) => {
  return (
    <>
      {optionList.map((item) => (
        <FilterOption key={item}>
          <CheckboxField
            label={
              <ColorOption>
                <ColorTag color={item.toLowerCase()} />
                <span>{item && getLabel(item)}</span>
              </ColorOption>
            }
            id={item}
            checked={activeValue?.includes(item)}
            onChange={() => {
              const newValue = activeValue.includes(item)
                ? activeValue.filter((val) => val !== item)
                : [...activeValue, item];

              updateFilter('seo_colors', newValue);
            }}
            meta={{ touched: true }}
          />
        </FilterOption>
      ))}
    </>
  );
};
